export class FetchError extends Error {
  body: unknown
  status: number

  constructor(status: number, body: unknown) {
    super('') // Call the parent class's constructor
    Object.setPrototypeOf(this, FetchError.prototype)
    this.name = 'FetchError' // Optional: set the error name
    this.status = status // HTTP status code
    this.body = body // Response body

    // Capture stack trace
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError)
    }
  }
}
